import border from '../../border';

const custom = (params) => border.active.custom(params);

export default custom;
